
import { GoogleGenerativeAI } from '@google/generative-ai';

const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

export async function analyzeTaskContent(title, description) {
  if (!GEMINI_API_KEY) {
    console.error("Gemini API Key not found for AI analysis.");
    return { category: 'Other', sentimentScore: null, entities: [] };
  }

  const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
  const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

  const textToAnalyze = `${title}. ${description}`;

  try {
    // --- Prompt for Categorization ---
    const categoryPrompt = `Categorize the following task into one of these categories: Work, Personal, Shopping, Health, Learning, Finance, Other. 
    Only return the category name, nothing else.
    Task: "${textToAnalyze}"`;
    const categoryResult = await model.generateContent(categoryPrompt);
    const category = categoryResult.response.text().trim();

    // --- Prompt for Sentiment Analysis ---
    // Asking for a score helps to standardize the output
    const sentimentPrompt = `Analyze the sentiment of the following task description on a scale from -5 (very negative) to 5 (very positive).
    Only return the single integer number.
    Task: "${textToAnalyze}"`;
    const sentimentResult = await model.generateContent(sentimentPrompt);
    const sentimentText = sentimentResult.response.text().trim();
    const sentimentScore = parseInt(sentimentText, 10);

    // --- Prompt for Entity Extraction (Optional, if you want to use it later) ---
    const entityPrompt = `Extract up to 3 key entities (nouns, proper nouns, important keywords) from the following task description.
    Return them as a comma-separated list, e.g., "report, client, deadline".
    Task: "${textToAnalyze}"`;
    const entityResult = await model.generateContent(entityPrompt);
    const entitiesText = entityResult.response.text().trim();
    const extractedEntities = entitiesText ? entitiesText.split(',').map(e => e.trim()) : [];


    return {
      category: category || 'Other', // Provide a fallback
      sentimentScore: isNaN(sentimentScore) ? null : sentimentScore,
      extractedEntities: extractedEntities
    };

  } catch (error) {
    console.error("Error during automated AI analysis:", error);
    // Return defaults or previous values on error
    return { category: 'Other', sentimentScore: null, entities: [] };
  }
}
